import P2Regular from 'components/typography/P2Regular';

interface SimpleValueFormatterProps {
  value: unknown;
  /** When provided, numbers are formatted with this many decimal places using `toFixed`. Otherwise `toLocaleString('sk')` is used. */
  precision?: number;
}

/**
 * Renders a raw cell value as formatted text inside P2Regular.
 * - Dates (ISO `YYYY-MM-DD`) are formatted as localised Slovak date strings.
 * - Numbers are formatted either with a fixed precision or with `toLocaleString('sk')`.
 * - Everything else is rendered as a plain string.
 * Returns `null` for empty / nullish values.
 */
export default function SimpleValueFormatter({ value, precision }: SimpleValueFormatterProps) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (typeof value === 'boolean') {
    return <P2Regular lineClamp={2}>{value ? 'Áno' : 'Nie'}</P2Regular>;
  }

  const str = String(value);
  const isDate = /\d{4}-\d{2}-\d{2}/.test(str);
  const isNumber = !isNaN(Number(value));

  if (isDate) {
    return <P2Regular lineClamp={2}>{new Date(str).toLocaleDateString('sk')}</P2Regular>;
  }

  if (isNumber) {
    return (
      <P2Regular lineClamp={2}>
        {precision !== undefined
          ? Number(value).toFixed(precision).replace('.', ',')
          : Number(value).toLocaleString('sk')}
      </P2Regular>
    );
  }

  return <P2Regular lineClamp={2}>{str}</P2Regular>;
}
